import { Box, IconContentView, Text } from 'ui'
import { DollarSign } from 'lucide-react'
import { formatCurrency } from 'lib/string'
import { getShiftBillRate, getShiftBonus } from 'lib/payment'
import { useShiftDetail } from './useShiftDetail'

export const ShiftDetailBillRate = () => {
  const { shift } = useShiftDetail()
  if (!shift) return null

  const billRate = formatCurrency(getShiftBillRate(shift))
  const bonus = getShiftBonus(shift)

  return (
    <Box>
      <IconContentView icon={<DollarSign size={20} />} iconProps={{ mr: 3 }}>
        <Box>
          <Text fontWeight={'bold'}>Bill Rate</Text>
          <Text>
            {billRate}
            {'/hour per worker'}
            {bonus && Number(bonus) > 0
              ? ` • Bonus: ${formatCurrency(bonus)}`
              : null}
          </Text>
        </Box>
      </IconContentView>
    </Box>
  )
}
